import { useEffect, useState } from 'react';
import { getForecastPredictions, getForecastPredictionsByIds } from '../../../services/reservation';

const useForecasts = (id, queryParams) => {
	const [data, setData] = useState([]);
	const [params, setParams] = useState();
	const [pagination, setPagination] = useState();
	const [currentPage, setCurrentPage] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null)

	const changePage = (page) => {
		setCurrentPage(page);
	}

	const changeLoading = (loading) => {
		setIsLoading(loading);
	}

	const fetchForecast = async () => {
		setIsLoading(true);
		try {
			const filteredResponse = (response) => {
				const filterNullValues = response?.data ? response?.data?.filter(Boolean) : response?.filter(Boolean)
				const filterEmptyObjects = filterNullValues.filter(obj => Object.keys(obj).length !== 0);
				setData(filterEmptyObjects);
			}		
			let response
			if (id) {
				response = await getForecastPredictionsByIds({ ...params, reservationId: id })
				filteredResponse(response);
			}
			else if (queryParams && Object.keys(queryParams).length > 0) {
				response = await getForecastPredictions({ ...queryParams, page: currentPage })
				setParams(queryParams);
				filteredResponse(response);
				setPagination(response.pagination);
			}
			else {
				response = await getForecastPredictions({ ...params, page: currentPage })
				filteredResponse(response);
				setPagination(response.pagination);
			}
		}
		catch (error) {
			console.error(error);
			setError(error)
		}
		finally {
			setIsLoading(false);
		}
	}

	useEffect(() => {
		fetchForecast()
	}, [params, currentPage])

	return {
		data,
		setData,
		error,
		params,
		setParams,
		currentPage,
		changePage,
		changeLoading,
		isLoading,
		pagination
	};
};

export default useForecasts;